module.exports = __webpack_public_path__ + "static/img/image025.0a7c267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image025.png
// module id = PbW5
// module chunks = 1